module.exports = __webpack_public_path__ + "images/88409faa.img5-cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img5-cht.png
// module id = 412
// module chunks = 0